import React from "react"
import moment from "moment"
import cookie from "react-cookies"
import queryString from "query-string"
import { connect } from "react-redux"
import { geocodeByAddress, getLatLng } from "react-places-autocomplete"
import { isIOS } from "react-device-detect"
import DateRangePicker from 'react-bootstrap-daterangepicker'

import { init } from "../../model/car"
import { searchInHouse } from "../../model/common"

import {setFilter, searchCarList, searchCarListMore} from "../../actions/carFindingAct"

import { commonErr } from "../common/errors"
import { stypes } from "../common/common"

import Header from "../common/header"
import Footer from "../common/footer"
import SideBar from "../common/sidebar"

import Filter from "./filter"
import ListView from "./listview"
import HereAutoComplete from "../common/hereautocomplete"


const defPriceRange = {
	min: 500,
	max: 10000,
	step: 100
};

const defLimitKMRange = {
	min: 0,
	max: 550,
	step: 50
};

const defLimitKMPriceRange = {
	min: 0,
	max: 15,
	step: 5
};

const defDPriceRange = {
	min: 0,
	max: 50,
	step: 5
};

const defFuelCRange = {
	min: 0,
	max: 30,
	step: 5
};

const defYearRange = {
	min: 2000,
	max: moment().year().valueOf(),
	step: 5
};

const defSeatRange = {
	min: 2,
	max: 16,
	step: 2
};

const defRadiusRange = {
	min: 5,
	max: 50,
	step: 3
}


const calendarTemplate = '<div class="daterangepicker dropdown-menu">' +
	'<div class="calendar left">' +
	'<div class="daterangepicker_input hidden">' +
	'<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
	'<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	'<div class="calendar-time">' +
	'<div></div>' +
	'<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	'</div>' +
	'</div>' +
	'<div class="calendar-table"></div>' +
	'</div>' +
	'</div>' +
'</div>';

const bookingTimes = [];
for (var i = 0; i < 1440; i = i + 30) {
	const time = i;
	const hour = (time - time % 60) / 60;
	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
	const min = time % 60;
	const minLabel = min < 10 ? `0${min}` : `${min}`;
	bookingTimes.push({ value: time, label: `${hourLabel}:${minLabel}` });
}

const placesAutocompleteStyle = {
autocompleteContainer: {
	position: 'absolute',
	top: '100%',
	backgroundColor: 'rgba(0, 0, 0, 0.7)',
	width: '100%',
	border: 'none',
	zIndex: '10000'
},
autocompleteItem: {
	backgroundColor: 'rgba(0, 0, 0, 0.7)',
	padding: '10px',
	color: '#f0f0f0',
	cursor: 'pointer',
	display: 'flex', 
	justifyContent: 'flex-start',
	flexWrap: 'wrap'
},
autocompleteItemActive: {
		backgroundColor: '#6c6c6e',
		color: '#fffff',
},
}



class CarFinding extends React.Component {
	constructor(props) {
			super(props);

			this.state = {
					err: commonErr.INNIT,
					errMsg: "",
					errMsgBox: "",
					popupId: "",
			
					isOpenFilterBox: false,
				
					isShowConfirmPopup: false,
		
					isOpenSearching: false,
					showSearchTime: true,

					location: props.location,
					oriUrl: window.location.href
			}

			// this.toogleFilterBox = this.toogleFilterBox.bind(this);
			this.setFilter = this.setFilter.bind(this);
			this.resetFilter = this.resetFilter.bind(this);
			this.searchCar = this.searchCar.bind(this);
			this.showMessageBox = this.showMessageBox.bind(this);
			this.hideMessageBox = this.hideMessageBox.bind(this);
			this.setAddressPlaceHolder = this.setAddressPlaceHolder.bind(this);
			this.onSelectFromAddr = this.onSelectFromAddr.bind(this);
			this.togglePopup = this.togglePopup.bind(this);
			this.hideConfirm = this.hideConfirm.bind(this);

			this.onStartTimeChange = this.onStartTimeChange.bind(this);
			// this.toogleSearching = this.toggleSearching.bind(this);
		

	}



	componentDidMount() {
			var platformType;
			var startDate;
			var endDate;
			var startTime;
			var endTime;
			var lat;
			var lng;
			var address=this.props.carFinding.filter.address;
			var stype = stypes.SD;

			// if(this.props.carFinding.filter.isOpenSearching){
			// 	this.setState({
			// 		isOpenSearching: this.props.carFinding.filter.isOpenSearching
			// 	})
			// }

			//overide filter by query params
			if (this.props.location && this.props.location.search) {
					const query = queryString.parse(this.props.location.search);

					if (query.startDate) {
							startDate = moment(query.startDate * 1);
							startTime = startDate.get("hour") * 60 + startDate.get("minute");
					}
					if (query.endDate) {
							endDate = moment(query.endDate * 1);
							endTime = endDate.get("hour") * 60 + endDate.get("minute");
					}
					if (query.lat) {
							lat = query.lat * 1;
					}
					if (query.lng) {
							lng = query.lng * 1;
					}
					if (query.address) {
							address = query.address;
					}
					
					if (query.platformType) { 
						platformType = parseInt(query.platformType)
					}
	

					//GA tracking
					if (query.utm_source) {
							cookie.save("_utm_src", query.utm_source, { path: '/' });
							cookie.save("_utm_src", query.utm_source, { path: '/', domain: '.mioto.vn' });
					}
					if (query.utm_ext) {
							cookie.save("_utm_ext", query.utm_ext, { path: '/' });
							cookie.save("_utm_ext", query.utm_ext, { path: '/', domain: '.mioto.vn' });
					} else {
							cookie.remove("_utm_ext", { path: '/' });
							cookie.remove("_utm_ext", { path: '/', domain: '.mioto.vn' });
					}          
			}

			//use cookies for missing params
			if (!address) {
					const cAddress = cookie.load("_maddr");
					if (cAddress) {
							address = cAddress;
					}
			}

			// check valid cookie before set
			if(cookie.load("_mstartts") < moment().add(2, "hours").valueOf() || cookie.load("_mendts") < moment().add(2, "hours").valueOf()){
					cookie.remove("_mstartts", { path: '/' });
					cookie.remove("_mendts", { path: '/' });
			}

			const cStartTs = cookie.load("_mstartts");
			if (cStartTs) {
				const cStartDate = moment(cStartTs * 1);
					startDate = cStartDate;
					startTime = startDate.get("hour") * 60 + startDate.get("minute");
			}

			const cEndTs = cookie.load("_mendts");
			if (cEndTs) {
					endDate = moment(cEndTs * 1);
					endTime = endDate.get("hour") * 60 + endDate.get("minute");
			}
					

			if (address && address !== "") {
					if (lat && lng) {
							if (startDate && endDate) {
									const filter = {
											...this.props.carFinding.filter,
											platformType: platformType,
											stype: stype,
											address: address,
											lat: lat,
											lng: lng,
											startDate: startDate,
											endDate: endDate,
											startTime: startTime,
											endTime: endTime,
											transmission: 1
									}
									this.setState({
											platformType: platformType,
											stype: stype,
											startDate: startDate,
											endDate: endDate,
											startTime: startTime,
											endTime: endTime,
											baseFilter: { ...filter }
									});
									this.setFilter(filter);
									this.searchCar(filter);
							} else {
									init().then(resp => {
											const timeInit = resp.data.data;
											if (timeInit) {
													const filter = {
															...this.props.carFinding.filter,
															platformType: platformType,
															stype: stype,
															address: address,
															lat: lat,
															lng: lng,
															startDate: moment(timeInit.startTime),
															endDate: moment(timeInit.endTime),
															startTime: moment(timeInit.startTime).get("hour") * 60 + moment(timeInit.startTime).get("minute"),
															endTime: moment(timeInit.endTime).get("hour") * 60 + moment(timeInit.endTime).get("minute"),
															transmission: 1
													}
													this.setState({
															baseFilter: { ...filter },
															platformType: platformType,
															addressBanner: address != "" && address
													});
													this.setFilter(filter);
													this.searchCar(filter);
											} else {
													this.setState({
															err: commonErr.FAIL,
															errMsg: "Thời gian tìm kiếm không hợp lệ."
													});
											}
									})
							}
					} else {
						searchInHouse(address).then((response) => {

								 
							// const loc = response.data.items[0].position
							const loc = response.data.data.locations[0]
						
					
			

											lat = loc.lat;
											lng = loc.lon;

											if (startDate && endDate) {
													const filter = {
															...this.props.carFinding.filter,
															stype: stype,
															address: address,
															lat: lat,
															lng: lng,
															startDate: startDate,
															endDate: endDate,
															platformType: platformType,
															transmission: 1
													}
													this.setState({
															baseFilter: { ...filter },
															addressBanner: address != "" && address,
															startDate: startDate,
															endDate: endDate,
															startTime: startTime,
															endTime: endTime,
															platformType: platformType,
													});
													this.setFilter(filter);
													this.searchCar(filter);
											} else {
													init().then(resp => {
															const timeInit = resp.data.data;
															if (timeInit) {
																	const filter = {
																			...this.props.carFinding.filter,
																			stype: stype,
																			address: address,
																			lat: lat,
																			lng: lng,
																			startDate: moment(timeInit.startTime),
																			endDate: moment(timeInit.endTime)
																	}
																	this.setState({
																			baseFilter: { ...filter },
																			addressBanner: address != "" && address
																	});
																	this.setFilter(filter);
																	this.searchCar(filter);
															} else {
																	this.setState({
																			err: commonErr.FAIL,
																			errMsg: "Thời gian tìm kiếm không hợp lệ."
																	});
															}
													})
											}
									})
									.catch(error => {
											this.setState({
													err: commonErr.FAIL,
													errMsg: "Địa chỉ tìm kiếm không hợp lệ.",
													startDate: startDate,
													endDate: endDate,
													startTime: startTime,
													endTime: endTime
											});
									});
					}
			} else {
					this.setState({
							err: commonErr.FAIL,
							errMsg: "Địa chỉ tìm kiếm không hợp lệ."
					});
			}

	}

	

	setFilter(filter) {
			this.props.dispatch(setFilter(filter));
	}

	resetFilter() {
			const { startDate, endDate, address, lat, lng, minMiles } = this.props.carFinding.filter;
			const filter = {
					...this.state.baseFilter,
					startDate: startDate,
					endDate: endDate,
					address: address,
					lat: lat,
					lng: lng,
					minMiles: minMiles,
			}
			
			this.setFilter(filter);
			const allFeatures = this.state.customFilterConfig.allFeatures;
			
			for (var i = 0; i < allFeatures.length; ++i) {
					allFeatures[i].checked = false;
			}
		this.searchCar(filter);
	
	}

	searchCarList = (f) => {
			const filter = this.standarizeFilter(f);

			this.props.dispatch(searchCarList(filter));
	}

	searchCarListMore = (f) => {
			const filter = this.standarizeFilter(f);
			this.props.dispatch(searchCarListMore(filter));
	}


	standarizeFilter(filter) {
			const customFilterConfig = this.state.customFilterConfig;

			const minPrice = (customFilterConfig && customFilterConfig.minPrice) ? customFilterConfig.minPrice / 1000 : defPriceRange.min;
			const maxPrice = (customFilterConfig && customFilterConfig.maxPrice) ? customFilterConfig.maxPrice / 1000 : defPriceRange.max;
			const minLimitKM = (customFilterConfig && customFilterConfig.minLimitKM) ? customFilterConfig.minLimitKM : defLimitKMRange.min;
			const maxLimitKM = (customFilterConfig && customFilterConfig.maxLimitKM) ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
			const maxLimitKMPrice = (customFilterConfig && customFilterConfig.maxLimitKMPrice) ? customFilterConfig.maxLimitKMPrice / 1000 + 5 : defLimitKMPriceRange.max;
			const maxDPrice = (customFilterConfig && customFilterConfig.maxDeliveryPrice) ? customFilterConfig.maxDeliveryPrice / 1000 : defDPriceRange.max;
			const minFuelC = (customFilterConfig && customFilterConfig.minFuelC) ? customFilterConfig.minFuelC : defFuelCRange.min;
			const maxFuelC = (customFilterConfig && customFilterConfig.maxFuelC) ? customFilterConfig.maxFuelC : defFuelCRange.max;
			const minSeat = (customFilterConfig && customFilterConfig.seatMin) ? customFilterConfig.seatMin : defSeatRange.min;
			const maxSeat = (customFilterConfig && customFilterConfig.seatMax) ? customFilterConfig.seatMax : defSeatRange.max;
			const minYear = (customFilterConfig && customFilterConfig.yearMin) ? customFilterConfig.yearMin : defYearRange.min;
			const maxYear = (customFilterConfig && customFilterConfig.yearMax) ? customFilterConfig.yearMax : defYearRange.max;
			const maxRadius = (customFilterConfig && customFilterConfig.maxRadius) ? customFilterConfig.maxRadius : defRadiusRange.max;

			return {
					...filter,
					minPrice: (filter.minPrice > minPrice) ? filter.minPrice : 0,
					maxPrice: (filter.maxPrice < maxPrice) ? filter.maxPrice : 0,
					dPrice: (filter.directDelivery && filter.dPrice < maxDPrice) ? filter.dPrice : -1,
					limitKM: (filter.limitKM < maxLimitKM) ? filter.limitKM : -1,
					limitKMPrice: (filter.limitKM > minLimitKM && filter.limitKMPrice < maxLimitKMPrice) ? filter.limitKMPrice : -1,
					fuelC: (filter.fuelC > minFuelC && filter.fuelC < maxFuelC) ? filter.fuelC : 0,
					minSeat: (filter.minSeat > minSeat && filter.minSeat < maxSeat) ? filter.minSeat : 0,
					maxSeat: (filter.maxSeat > minSeat && filter.maxSeat < maxSeat) ? filter.maxSeat : 0,
					minYear: (filter.minYear > minYear && filter.minYear < maxYear) ? filter.minYear : 0,
					maxYear: (filter.maxYear > minYear && filter.maxYear < maxYear) ? filter.maxYear : 0,
					radius: (filter.radius * 1.60934 >= maxRadius) ? 0 : filter.radius
			}
	}

	searchCar(filter) {
	

			//save search params cookies
			cookie.save("_maddr", filter.address, { path: '/' });
			cookie.save("_mstartts", filter.startDate.valueOf(), { path: '/' });
			cookie.save("_mendts", filter.endDate.valueOf(), { path: '/' });

	
			this.searchCarList(filter);
			
	}

	setAddressPlaceHolder(msg) {
			this.setState({
					addressPlaceHolder: msg
			});
	}

	onAddressChange(address) {
			const filter = {
					...this.props.carFinding.filter,
					address: address,
					// isOpenSearching: true				
			}
			this.setFilter(filter);
	}

	onAddressFocus(e) {
			this.setState({
					addressPlaceHolder: "Nhập địa chỉ bạn muốn tìm kiếm."
			});
			const filter = {
					...this.props.carFinding.filter,
					address: "",
					isOpenSearching: true
			}
			this.setFilter(filter);
	}

	onSelectFromAddr = (address) => {
		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
					errMsg = "Trình duyệt không được cho phép truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
					errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
					err: commonErr.FAIL,
					errMsg: errMsg
			});
			this.showMessageBox(errMsg);
	} else if (address.err === commonErr.LOADING) {
			this.setState({
					err: commonErr.LOADING,
			});
	} else {
			this.setState({
					err: commonErr.LOADING,
			});

			if (address.address !== "") {
				this.setState({
					err: commonErr.SUCCESS,
					addressBanner: address.address
				});

				const filter = {
						...this.props.carFinding.filter,
						address: address.address,
						lat: address.lat,
						lng: address.lng,
						isOpenSearching: true
				}

				this.setFilter(filter);
				this.searchCar(filter);

			} else {
							this.setState({
									err: commonErr.FAIL,
									errMsg: "Địa chỉ không hợp lệ."
							});
					}
				}
		}


	onStartDateChange(event, picker) {
			event.preventDefault();
			if(picker.startDate){
					const startDate = picker.startDate;
					var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;
					var endTime = endDate.get("hour") * 60 + endDate.get("minute");
					var hour = this.state.startTime ? (this.state.startTime -  this.state.startTime % 60) / 60 : (this.props.carFinding.filter.startTime -  this.props.carFinding.filter.startTime % 60) / 60;
					var minute = this.state.startTime ? this.state.startTime % 60 : this.props.carFinding.filter.startTime % 60;
					startDate.set({
							hour: hour,
							minute: minute,
							second: 0,
							milliseconds: 0
					});

					if (endDate <= startDate) {
							endDate = startDate.clone();
							endDate.add(23, "hour");
							endTime = moment(endDate).get("hour") * 60 + moment(endDate).get("minute");
					}

					//save cookies
					cookie.save("_mstartts", startDate.valueOf(), { path: '/' });
					cookie.save("_mendts", endDate.valueOf(), { path: '/' });
					
					this.setState({
									startDate: startDate,
									endDate: endDate,
									endTime: endTime,
					})
					
					this.toogleSearchTime();					
					const filter = {
							...this.props.carFinding.filter,
							startDate: startDate,
							endDate: endDate,
							isOpenSearching: true
					}

					// this.setFilter(filter);
					this.toogleSearchTime();
					this.searchCar(filter);
			}				
	}

	onEndDateChange(event, picker) {
			event.preventDefault();
			if(picker.startDate && picker.endDate){
					const startDate = picker.startDate;
					startDate.set({
							hour: (this.state.startTime -  this.state.startTime % 60) / 60,
							minute: this.state.startTime % 60,
							second: 0,
							milliseconds: 0
					});
					const endDate = picker.endDate;
					endDate.set({
							hour: (this.state.endTime -  this.state.endTime % 60) / 60,
							minute: this.state.endTime % 60,
							second: 0,
							milliseconds: 0
					});
					if (endDate < startDate) {
									return;
					}

					//save cookies
					cookie.save("_mstartts", startDate.valueOf(), { path: '/' });
					cookie.save("_mendts", endDate.valueOf(), { path: '/' });

					this.setState({
									startDate: startDate,
									endDate: endDate
					})
					
					const filter = {
							...this.props.carFinding.filter,
							startDate: startDate,
							endDate: endDate,
							isOpenSearching: true
					}
	
					this.setFilter(filter);
					this.searchCar(filter);
			}		
	}

	onDateRangeChange(event, picker) {
			event.preventDefault();
			const startDate = picker.startDate.startOf("minute");
			const endDate = picker.endDate.startOf("minute");

			if (startDate > endDate
					|| (startDate.isSame(this.props.carFinding.filter.startDate) && endDate.isSame(this.props.carFinding.filter.endDate))) {
					return;
			}

			const filter = {
					...this.props.carFinding.filter,
					startDate: startDate,
					endDate: endDate
			}

			this.setFilter(filter);
			this.searchCar(filter);
	}

	onStartTimeChange(event) {
			const time = event.target.value;
			const hour = (time - time % 60) / 60;
			const min = time % 60;
			var startDate = moment(this.state.startDate ? this.state.startDate : this.this.props.carFinding.filter.startDate).set({
					hour: hour,
					minute: min,
					second: 0,
					milliseconds: 0
			});

			var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;
			if (endDate && endDate.isValid() && endDate <= startDate) {
					endDate = startDate.clone().add(23, "hour");						
			}

			cookie.save("_mstartts", startDate.valueOf(), { path: '/' });
			cookie.save("_mendts", endDate.valueOf(), { path: '/' });

			this.setState({
				startDate: startDate,
				startTime: startDate.get("hour") * 60 + startDate.get("minute"),
				endDate: endDate,								
				endTime: endDate.get("hour") * 60 + endDate.get("minute"),
				err: commonErr.SUCCESS,
				errMsg: ""
			});

			const filter = {
					...this.props.carFinding.filter,
					startDate: startDate,
					endDate: endDate,
					isOpenSearching: true
			}

			this.setFilter(filter);
			this.searchCar(filter);
	}

	onEndTimeChange(event) {
			const time = event.target.value;
			const hour = (time - time % 60) / 60;
			const min = time % 60;
			var endDate = moment(this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate).set({
				hour: hour,
				minute: min,
				second: 0,
				milliseconds: 0
			});

			var startDate = this.state.startDate ? this.state.startDate : this.props.carFinding.filter.starstartDatetTime;
			if (startDate && startDate.isValid() && endDate <= startDate) {
				startDate = endDate.clone().add(-23, "hour");
			}

			cookie.save("_mstartts", startDate.valueOf(), { path: '/' });
			cookie.save("_mendts", endDate.valueOf(), { path: '/' });

			this.setState({
				startDate: startDate,
				startTime: startDate.get("hour") * 60 + startDate.get("minute"),
				endDate: endDate,								
				endTime: endDate.get("hour") * 60 + endDate.get("minute"),
				err: commonErr.SUCCESS,
				errMsg: ""
			});

			const filter = {
					...this.props.carFinding.filter,
					startDate: startDate,
					endDate: endDate,
					isOpenSearching: true
			}

			this.setFilter(filter);
			this.searchCar(filter);
	}

	showMessageBox(msg) {
			this.setState({
					errMsgBox: msg
			});
	}

	hideMessageBox() {
			this.setState({
					errMsgBox: ""
			});
	}

	togglePopup(carGroupId) {
		this.setState({
			popupId: carGroupId,
			isShowConfirmPopup: !this.state.isShowConfirmPopup,
		});
	}

	hideConfirm() {
		this.setState({
			isShowConfirmPopup: false,
		});
	}
// 	hasFilter(filter, customFilterConfig) {
// 			if(filter === undefined || customFilterConfig === undefined) {
// 					gh+return false;
// 			}
// 			const maxPrice = (customFilterConfig && customFilterConfig.maxPrice) ? customFilterConfig.maxPrice / 1000 : defPriceRange.max;
// 			const maxLimitKM = (customFilterConfig && customFilterConfig.maxLimitKM) ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
// 			const maxLimitKMPrice = (customFilterConfig && customFilterConfig.maxLimitKMPrice) ? customFilterConfig.maxLimitKMPrice / 1000 + 5 : defLimitKMPriceRange.max;
// 			const maxDeliveryPrice = (customFilterConfig && customFilterConfig.maxDeliveryPrice) ? customFilterConfig.maxDeliveryPrice / 1000 : defDPriceRange.max;
// 			const minFuelC = (customFilterConfig && customFilterConfig.minFuelC) ? customFilterConfig.minFuelC : defFuelCRange.min;
// 			const minSeat = (customFilterConfig && customFilterConfig.seatMin) ? customFilterConfig.seatMin : defSeatRange.min;
// 			const maxSeat = (customFilterConfig && customFilterConfig.seatMax) ? customFilterConfig.seatMax : defSeatRange.max;
// 			const minYear = (customFilterConfig && customFilterConfig.yearMin) ? customFilterConfig.yearMin : defYearRange.min;
// 			const maxYear = (customFilterConfig && customFilterConfig.yearMax) ? customFilterConfig.yearMax : defYearRange.max;
// 			const maxRadius = (customFilterConfig && customFilterConfig.maxRadius) ? customFilterConfig.maxRadius : defRadiusRange.max;
// 			const sortValue = (customFilterConfig && customFilterConfig.sort) ? customFilterConfig.sort : "op";
		
// 			return filter.maxPrice < maxPrice
// 					|| filter.vehicleType != "0" || filter.vehicleMake != "0" || filter.vehicleModel != "0"
// 					|| filter.minSeat > minSeat || filter.maxSeat < maxSeat
// 					|| filter.minYear > minYear || filter.maxYear < maxYear
// 					|| filter.instantBooking === true || filter.directDelivery === true
// 					|| filter.dPrice < maxDeliveryPrice
// 					|| filter.transmission != "0"
// 					|| filter.features.length > 0
// 					|| filter.fuel != "0" || filter.fuelC > minFuelC
// 					|| filter.limitKM < maxLimitKM
// 					|| filter.limitKMPrice < maxLimitKMPrice
// 					|| filter.radius * 1.60934 < maxRadius
// 					|| filter.pVerified === true
// 					|| filter.sort != sortValue[0].id
// 					|| filter.supportIns === true 
// 					|| filter.supportPassport === true
// }


	toogleSearchTime() {
		this.setState({
			showSearchTime: !this.state.showSearchTime,
		})
	}
	
	checkOpenSearchBox(){
		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: this.state.isOpenSearching
		}
		this.setFilter(filter);
	}

	render() {
		var content;
		const { platformType } = this.props.appInit;

			if (this.state.err >= commonErr.SUCCESS) {
				
					content = <ListView platformType={platformType} startDate={this.state.startDate} endDate={this.state.endDate} stype={stypes.SD} show={this.state.isShowConfirmPopup} hideConfirm={this.hideConfirm} searchCarListMore={this.searchCarListMore.bind(this)} togglePopup={this.togglePopup} popupId={this.state.popupId} />
					
			} else {
					content = <div className="module-map">
							<div className="has-list">
									<div className="map-container">
											{/* <MessageLine message={this.state.errMsg !== "" ? this.state.errMsg : "Đã có lỗi xảy ra. Vui lòng thử lại."} /> */}
									</div>
							</div>
					</div>
			}
			return <div className="mioto-layout page-wrapper">
							<Header />
							<SideBar />
							<div className="content-wrapper">
								<div className="page-content fade-in-up">
									<div className="ibox finding-control" id="calendar-default">
										<div className="ibox-body">
											<div className="row">
												<div className="col-md-4">
													<div className="form-group d-flex location">
														<label className="inline-label">Địa điểm</label>
														{this.state.err === commonErr.LOADING && <div className="wrap-input wrap-input-transparent">
																{/* <LoadingInlineSmall /> */}
														</div>}
														<div className={`wrap-input wrap-input-transparent ${this.state.err === commonErr.LOADING ? "hidden" : ""}`}>
																{/* <PlacesAutocomplete
																		classNames={{ input: "form-control form-control-line" }}
																		inputProps={{
																				value: this.props.carFinding.filter.address,
																				onChange: this.onAddressChange.bind(this),
																				onFocus: this.onAddressFocus.bind(this),
																				placeholder: this.state.addressPlaceHolder
																		}}
																		styles={placesAutocompleteStyle}
																		onSelect={this.onSelectFromAddr}
																		isUseCurrentLocation={true}
																		googleLogo={false}
																		options={{ componentRestrictions: { country: ['vn'] } }} /> */}

														<HereAutoComplete 
															inputProps={{
																value: this.props.carFinding.filter.address,
																onChange: this.onAddressChange,
																onFocus: this.onAddressFocus,
																placeholder: this.state.addressPlaceHolder
															}}
															styles={placesAutocompleteStyle}
															focusAddress={true}
															onSelect={(address) => this.onSelectFromAddr(address)} />
														</div>
													</div>
												</div>
													{this.state.showSearchTime && <div className="col-md-4">
													<div className="form-group d-flex location">
																	<label className="inline-label" >Bắt đầu</label>
																	<div className="form-control form-control-line wrap-daterange">
																					<DateRangePicker
																							startDate={this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate}
																							endDate={this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate}
																							minDate={moment()}
																							maxDate={moment().add(3, "months")}
																							timePicker={false}
																							singleDatePicker={true}
																							singleSelect={true}
																							autoApply={true}
																							isIOs={isIOS}
																							timePickerIncrement={30}
																							linkedCalendars={false}
																							timePicker24Hour={true}
																							onHide={this.onStartDateChange.bind(this)}
																							buttonClasses={["hidden"]}
																							opens={"center"}
																							template={calendarTemplate}
																							parentEl={"#calendar-default"}>
																							<span className="value placeholder">{this.state.startDate ? this.state.startDate.format("DD/MM/YYYY") : (this.props.carFinding.filter.startDate ? this.props.carFinding.filter.startDate.format("DD/MM/YYYY") : "Chọn ngày")} <i className="i-chevron-down"></i></span>
																					</DateRangePicker>
																			</div>
																		<div className="wrap-select">
																			<select className="form-control form-control-line"  onChange={this.onStartTimeChange.bind(this)} value={this.state.startTime ? this.state.startTime : this.props.carFinding.filter.startDate.get("hour") * 60 + this.props.carFinding.filter.startDate.get("minute")}>
																					{bookingTimes.map(time => <option key={`s_${time.value}`} value={time.value}>{time.label} </option>)}
																			</select>
																		</div>
																	</div>		
															</div>}
															{this.state.showSearchTime && <div className="col-md-4">
																		<div className="form-group d-flex location">
																			<label className="inline-label">Kết thúc</label>
																			<div className="form-control form-control-line wrap-daterange">
																						<DateRangePicker
																							startDate={this.props.carFinding.filter.startDate}
																							endDate={this.props.carFinding.filter.endDate}
																							minDate={moment(this.props.carFinding.filter.startDate.valueOf())}
																							maxDate={moment().add(3, "months")}
																							timePicker={false}
																							singleDateRangePicker={true}
																							singleSelect={true}
																							autoApply={true}
																							isIOs={isIOS}
																							timePickerIncrement={30}
																							linkedCalendars={false}
																							timePicker24Hour={true}
																							pickingEndDateOnly={true}
																							onHide={this.onEndDateChange.bind(this)}
																							buttonClasses={["hidden"]}
																							opens={"center"}
																							template={calendarTemplate}
																							parentEl={"#calendar-default"}>
																							<span className="value placeholder">{this.state.endDate ? this.state.endDate.format("DD/MM/YYYY") : (this.props.carFinding.filter.endDate ? this.props.carFinding.filter.endDate.format("DD/MM/YYYY") : "Chọn ngày")} <i className="i-chevron-down"></i></span>
																					</DateRangePicker>
																			</div>
																			<div className="wrap-select">
																				<select onChange={this.onEndTimeChange.bind(this)} className="form-control form-control-line" value={this.state.endTime ? this.state.endTime : this.props.carFinding.filter.endDate.get("hour") * 60 + this.props.carFinding.filter.endDate.get("minute")}>
																					{bookingTimes.map(time => <option key={`e_${time.value}`} value={time.value}>{time.label} </option>)}
																				</select>
																				</div>	
																			</div>	
																	</div>}
																</div>
													</div>
											</div>
											<div className="row">
												<div className="col-md-3">
													<Filter filter={this.props.carFinding.filter} setFilter={this.setFilter} resetFilter={this.resetFilter} searchCar={this.searchCar} />
												</div>
												<div className="col-md-9">
													{content}
												</div>
											</div>
										</div>
								</div>
						</div>
		
	}
}

function mapState(state) {
	return {
			carFinding: state.carFinding,
			appInit: state.appInit,
	}
}

CarFinding = connect(mapState)(CarFinding);
export default CarFinding;


// WEBPACK FOOTER //
// ./src/components/car/carfinding.js